import { useState, useEffect } from "react";

import Swal from "sweetalert2";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db, storage } from "../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

import { Button, Input, Modal, ModalBody } from "reactstrap";

function AdminNewsArticlePage() {
  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const params = useParams();
  const articleId = params.articleId;

  const [newsArticle, setNewsArticle] = useState();
  const [image, setImage] = useState();
  const [title, setTitle] = useState();
  const [text, setText] = useState();

  const fetchNewsArticle = async () => {
    try {
      setIsLoading(true);

      const q = query(
        collection(db, "newsArticles"),
        where("uid", "==", articleId)
      );
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      setNewsArticle(data);
      setImage(data.image);
      setTitle(data.title);
      setText(data.text);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching news article");
    }
  };

  useEffect(() => {
    if (user) {
      fetchNewsArticle();
    }
    // eslint-disable-next-line
  }, [user]);

  const saveChanges = (item) => {
    Swal.fire({
      text: "Are you sure you want to save your changes to this article?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, SAVE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          const articleRef = query(
            collection(db, "newsArticles"),
            where("uid", "==", articleId)
          );
          const findArticles = await getDocs(articleRef);
          findArticles.forEach(async (article) => {
            const getArticle = doc(db, "newsArticles", article.id);
            await updateDoc(getArticle, {
              image: image,
              title: title,
              text: text,
            }).then(() => {
              fetchNewsArticle();
            });
          });

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          setIsLoading(false);
        }
      }
    });
  };

  const [isModalLoading, setIsModalLoading] = useState(false);
  const [newArticleImage, setNewArticleImage] = useState();

  const [
    changeNewsArticleImageModalIsVisible,
    setChangeNewsArticleImageModalIsVisible,
  ] = useState();
  const toggleChangeNewsArticleImageModal = () => {
    setChangeNewsArticleImageModalIsVisible(
      !changeNewsArticleImageModalIsVisible
    );
  };

  const selectNewArticleImage = () => {
    document.getElementById("selectImage").click();
  };

  const [newArticleImagePreview, setNewArticleImagePreview] = useState();
  // Handles input change event and updates state
  const handleChangeNewArticleImage = (event) => {
    setNewArticleImage(event.target.files[0]);
    setNewArticleImagePreview(URL.createObjectURL(event.target.files[0]));
  };

  const handleUploadNewArticleImage = () => {
    const storageRef = ref(
      storage,
      `assets/newsArticleImages/${newArticleImage.name}`
    );
    const uploadTask = uploadBytesResumable(storageRef, newArticleImage);
    setIsModalLoading(true);
    uploadTask.on(
      "state_changed",
      null,
      (error) => console.log(error),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          console.log("File available at", downloadURL);
          try {
            setNewArticleImage(downloadURL);

            const articleRef = query(
              collection(db, "newsArticles"),
              where("uid", "==", articleId)
            );
            const findArticles = await getDocs(articleRef);
            findArticles.forEach(async (article) => {
              const getArticle = doc(db, "newsArticles", article.id);
              await updateDoc(getArticle, {
                image: downloadURL,
              });
            });

            fetchNewsArticle();

            setIsModalLoading(false);
            toggleChangeNewsArticleImageModal();
          } catch (err) {
            console.error(err);
            alert(err.message);
            setIsModalLoading(false);
          }
        });
      }
    );
  };

  const deleteArticle = async () => {
    Swal.fire({
      text: "Are you sure you want to delete this article?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, DELETE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const articleRef = query(
            collection(db, "newsArticles"),
            where("uid", "==", articleId)
          );
          const findArticles = await getDocs(articleRef);
          findArticles.forEach(async (article) => {
            const getArticles = doc(db, "newsArticles", article.id);
            await deleteDoc(getArticles);
          });

          Swal.fire({
            text: "Article deleted successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          navigate(-1);

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting news article");
        }
      }
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        ARTICLE
      </h1>
      <div>
        <div
          onClick={toggleChangeNewsArticleImageModal}
          id="adminNewsArticleImageContainer"
        >
          <img
            alt="newsArticleImage"
            src={
              image
                ? image
                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
            }
            id="newsArticleImage"
          />
          <div className="adminNewsArticleImageOverlay">
            <Button className="primaryBtn">CHANGE</Button>
          </div>
        </div>
        <Modal
          id="changeNewsArticleImageModal"
          isOpen={changeNewsArticleImageModalIsVisible}
          toggle={toggleChangeNewsArticleImageModal}
          size={"lg"}
        >
          <ModalBody>
            <div className="modalHeader" style={{ marginBottom: "1rem" }}>
              <div></div>
              <IoClose onClick={toggleChangeNewsArticleImageModal} />
            </div>
            <div>
              <h1>CHANGE IMAGE</h1>
              {isModalLoading ? (
                <div
                  style={{
                    height: 300,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BarLoader color="#005EE1" />
                </div>
              ) : (
                <div style={{ marginTop: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "1rem",
                    }}
                  >
                    <img
                      alt="articleImage"
                      src={
                        newArticleImagePreview ? newArticleImagePreview : image
                      }
                      style={{ height: 250, width: 651.4 }}
                    />
                  </div>
                  <Input
                    id="selectImage"
                    type="file"
                    className="mainInput"
                    accept="image/*"
                    onChange={handleChangeNewArticleImage}
                    style={{ display: "none" }}
                  />
                  <Button
                    onClick={selectNewArticleImage}
                    className="secondaryBtn"
                    style={{ marginBottom: "0.5rem" }}
                  >
                    {newArticleImage?.name
                      ? newArticleImage.name
                      : "CHOOSE IMAGE (1310x500px)"}
                  </Button>
                  <Button
                    onClick={handleUploadNewArticleImage}
                    disabled={!newArticleImage?.name}
                    className="primaryBtn"
                  >
                    CHANGE
                  </Button>
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
        <input
          type="text"
          className="mainInput"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="The article's title"
          style={{ marginBottom: "0.5rem" }}
        />
        <textarea
          className="mainInput"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="The article's text"
          style={{ height: 300, borderRadius: 20, paddingTop: "1rem" }}
        ></textarea>
        <Button
          onClick={saveChanges}
          className="primaryBtn"
          style={{ marginTop: "0.5rem" }}
          disabled={
            newsArticle?.image === image &&
            newsArticle?.title === title &&
            newsArticle?.text === text
          }
        >
          SAVE
        </Button>
        <Button
          onClick={deleteArticle}
          className="secondaryBtn"
          style={{ marginTop: "0.5rem", boxShadow: "none" }}
        >
          DELETE
        </Button>
      </div>
    </div>
  );
}

export default AdminNewsArticlePage;
